import { render, staticRenderFns } from "./chat-message.vue?vue&type=template&id=655dfd36&"
import script from "./chat-message.vue?vue&type=script&lang=js&"
export * from "./chat-message.vue?vue&type=script&lang=js&"
import style0 from "./chat-message.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chat-message.vue"
export default component.exports